import Vue from 'vue'

Vue.mixin({
  methods: {
    displayAlert(type, message) {
      this.$root.$emit('showNotification', {
        type,
        message,
      })
    },
    /*
     * If you're not using a custom message, use the error response message
     */
    formatAlertError(error) {
      const [, message] = error.split(': ')
      return message.replace(/"/g, '')
    },
  },
})
